import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import './index.styles.css'
interface Props {
  withFormWrapper?: boolean
  hint?: React.ReactNode
  children: React.ReactNode
}

const FormWrapper = ({
  withFormWrapper = true,
  hint,
  children,
}: React.PropsWithChildren<Props>) => {
  if (!withFormWrapper) return <>{children}</>

  return (
    <Box flexDirection="row">
      <Box paddingLeft="s24" paddingRight="s64" className={'FormWrapper_forms'}>
        <Box paddingRight="s8">{children}</Box>
      </Box>
      {hint && hint}
    </Box>
  )
}

export default observer(FormWrapper)
